import Vue from "vue";
import Router from "vue-router";

import NProgress from "nprogress";
import "nprogress/nprogress.css";

const ContactTag = () =>
  import(/* webpackChunkName: "group-list" */ "@/views/contact/ContactTag.vue");
const HelloWorld = () =>
  import(/* webpackChunkName: "group-basic" */ "@/components/HelloWorld");
const DashboardLayout = () =>
  import(/* webpackChunkName: "group-basic" */ "@/layout/DashboardLayout");
const AuthLayout = () =>
  import(/* webpackChunkName: "group-login" */ "@/layout/AuthLayout");
const BuilderLayout = () =>
  import(/* webpackChunkName: "group-formbuilder" */ "@/layout/builder");
const ContentLayout = () =>
  import(/* webpackChunkName: "group-formbuilder" */ "@/layout/Content");

const Login = () =>
  import(/* webpackChunkName: "group-login" */ "@/views/Login");
const LoginReset = () =>
  import(/* webpackChunkName: "group-login" */ "@/views/LoginReset");
const ResetPassword = () =>
  import(/* webpackChunkName: "group-login" */ "@/views/ResetPassword");
const Register = () =>
  import(/* webpackChunkName: "group-register" */ "@/views/Register.vue");
const RegisterSuccess = () =>
  import(
    /* webpackChunkName: "group-register" */ "@/views/RegisterSuccess.vue"
  );
const RegisterAddress = () =>
  import(
    /* webpackChunkName: "group-register" */ "@/views/RegisterAddress.vue"
  );
const Dashboard = () =>
  import(/* webpackChunkName: "group-list" */ "@/views/Dashboard.vue");

const Campaign = () =>
  import(/* webpackChunkName: "group-list" */ "@/views/Campaign.vue");
const CreateCampaign = () =>
  import(
    /* webpackChunkName: "group-campCreate" */ "@/views/CreateCampaign.vue"
  );
const CreateAbSplit = () => import("@/views/CreateAbSplit.vue");
const CreateAutomation = () =>
  import("@/views/EmailAutomation/CreateAutomation.vue");

const Automation = () =>
  import(
    /* webpackChunkName: "group-list" */ "@/views/Automation/AutomationList.vue"
  );
const AutomationStep1 = () =>
  import(
    /* webpackChunkName: "group-create-automation" */ "@/views/Automation/AutomationStep1.vue"
  );
const AutomationStep2 = () =>
  import(
    /* webpackChunkName: "group-create-automation" */ "@/views/Automation/AutomationStep2.vue"
  );
const AutomationStep3 = () =>
  import(
    /* webpackChunkName: "group-create-automation" */ "@/views/Automation/AutomationStep3.vue"
  );
const AutomationReport = () =>
  import(
    /* webpackChunkName: "group-list" */ "@/views/Automation/AutomationReport.vue"
  );
const AutomationReportDetail = () =>
  import("@/views/Automation/AutomationReportDetail.vue");
//const AdvancedAutomationReport = () => import(/* webpackChunkName: "group-list" */ '@/views/Automation/advance/AutomationReport.vue')

const AdvAutomationStep1 = () =>
  import(
    /* webpackChunkName: "group-create-automation" */ "@/views/Automation/advance/AutomationStep1.vue"
  );

const Autoresponder = () =>
  import(/* webpackChunkName: "group-list" */ "@/views/Autoresponder.vue");
const CreateAutoresponder = () => import("@/views/CreateAutoresponder.vue");
const Recipients = () =>
  import(/* webpackChunkName: "group-list" */ "@/views/contact/Recipients.vue");
const ContactSummary = () =>
  import(
    /* webpackChunkName: "group-list" */ "@/views/contact/ContactSummary.vue"
  );
const CreateListType = () =>
  import(
    /* webpackChunkName: "group-recipCreate" */ "@/views/contact/CreateListType.vue"
  );
const CreateListImport = () =>
  import(
    /* webpackChunkName: "group-recipCreate" */ "@/views/contact/CreateListImport.vue"
  );
const CreateListUpload = () =>
  import(
    /* webpackChunkName: "group-recipCreate" */ "@/views/contact/CreateListUpload.vue"
  );
const CreateListUploadMap = () =>
  import(
    /* webpackChunkName: "group-recipCreate" */ "@/views/contact/CreateListUploadMap.vue"
  );
const CreateListCopyPaste = () =>
  import(
    /* webpackChunkName: "group-recipCreate" */ "@/views/contact/CreateListCopyPaste.vue"
  );
const CreateListIndividual = () =>
  import(
    /* webpackChunkName: "group-recipCreate" */ "@/views/contact/CreateListIndividual.vue"
  );
const RecipientsAnalytics = () =>
  import("@/views/contact/RecipientsAnalytics.vue");
const RecipientActivity = () => import("@/views/contact/RecipientActivity.vue");
const Segment = () =>
  import(/* webpackChunkName: "group-list" */ "@/views/Segment.vue");
const CreateSegment = () => import("@/views/CreateSegment.vue");
const AdminLogin = () =>
  import(/* webpackChunkName: "group-login" */ "@/views/Admin/Admin.vue");
const SegmentsAnalytics = () => import("@/views/SegmentsAnalytics.vue");
const Gallery = () =>
  import(/* webpackChunkName: "group-list" */ "@/views/Gallery.vue");

const TemplateThemes = () => import("@/views/TemplateThemes.vue");
const TemplateLayout = () =>
  import(
    /* webpackChunkName: "group-templateCreate" */ "@/views/TemplateLayout.vue"
  );
const TemplateCodeYourOwn = () =>
  import(
    /* webpackChunkName: "group-templateCreate" */ "@/views/TemplateCodeYourOwn.vue"
  );
const ImportHtml = () =>
  import(
    /* webpackChunkName: "group-templateCreate" */ "@/views/TemplateGallery/ImportHtml.vue"
  );
const PasteCode = () =>
  import(
    /* webpackChunkName: "group-templateCreate" */ "@/views/TemplateGallery/PasteCode.vue"
  );
const ImportZip = () =>
  import(
    /* webpackChunkName: "group-templateCreate" */ "@/views/TemplateGallery/ImportZip.vue"
  );
const TemplateBuilder = () =>
  import(
    /* webpackChunkName: "group-templateCreate" */ "@/views/TemplateGallery/TemplateBuilder.vue"
  );
const ChooseRecipients = () =>
  import(
    /* webpackChunkName: "group-campCreate" */ "@/views/ChooseRecipients.vue"
  );
const CampaignPreview = () =>
  import(
    /* webpackChunkName: "group-campCreate" */ "@/views/CampaignPreview.vue"
  );
const ScheduleSuccess = () => import("@/views/ScheduleSuccess.vue");
const CampaignReport = () =>
  import(/* webpackChunkName: "group-list" */ "@/views/CampaignReport.vue");
const AutoresponderReport = () =>
  import(
    /* webpackChunkName: "group-list" */ "@/views/AutoresponderReport.vue"
  );
const CampaignAnalytics = () => import("@/views/CampaignAnalytics.vue");
const ErrorView = () => import("@/views/ErrorView.vue");
const UnderMaintenance = () => import("@/views/UnderMaintenance.vue");
const Activate = () => import("@/views/Activate.vue");
const AccoutDashboard = () =>
  import(
    /* webpackChunkName: "group-account" */ "@/views/AccountSettings/AccountDashboard.vue"
  );
const AccountOverview = () =>
  import(
    /* webpackChunkName: "group-list" */ "@/views/AccountSettings/AccountOverview.vue"
  );
const AccountUserManagement = () =>
  import(
    /* webpackChunkName: "group-account" */ "@/views/AccountSettings/AccountUserManagement.vue"
  );
const AccountDelete = () =>
  import(
    /* webpackChunkName: "group-account" */ "@/views/AccountSettings/AccountDelete.vue"
  );
const AccountDomain = () =>
  import(
    /* webpackChunkName: "group-account" */ "@/views/AccountSettings/AccountDomain.vue"
  );
const AccountApiIntegrations = () =>
  import(
    /* webpackChunkName: "group-account" */ "@/views/AccountSettings/AccountApiIntegrations.vue"
  );
const AccountPlan = () =>
  import(
    /* webpackChunkName: "group-account" */ "@/views/AccountSettings/AccountPlan.vue"
  );
const AccountPlugins = () =>
  import(
    /* webpackChunkName: "group-account" */ "@/views/AccountSettings/Plugins/AccountPlugins.vue"
  );
const AccountRewards = () =>
  import(
    /* webpackChunkName: "group-account" */ "@/views/AccountSettings/AccountRewards.vue"
  );
const ListAnalytics = () => import("@/views/ListAnalytics.vue");
const AccountConversionPixel = () =>
  import(
    /* webpackChunkName: "group-account" */ "@/views/AccountSettings/AccountConversionPixel.vue"
  );
const AccountSenderManagement = () =>
  import(
    /* webpackChunkName: "group-account" */ "@/views/AccountSettings/AccountSenderManagement.vue"
  );
const AccountReplyId = () =>
  import(
    /* webpackChunkName: "group-account" */ "@/views/AccountSettings/AccountReplyId.vue"
  );
const CampaignTag = () =>
  import(
    /* webpackChunkName: "group-account" */ "@/views/AccountSettings/AccountCampaignTag.vue"
  );
const ContactProperties = () =>
  import(
    /* webpackChunkName: "group-account" */ "@/views/AccountSettings/ContactProperties.vue"
  );

const TemplatesList = () => import("@/views/McTemplates/TemplatesList");
const SubscriptionPreference = () =>
  import("@/views/SubscriptionPreference.vue");
const Listlogs = () =>
  import(/* webpackChunkName: "group-logs" */ "@/views/Listlogs.vue");

const StripePaymentMethod = () =>
  import(
    /* webpackChunkName: "group-account" */ "@/views/AccountSettings/StripePaymentMethod.vue"
  );
const AccountStripeInvoice = () =>
  import(
    /* webpackChunkName: "group-account" */ "@/views/AccountSettings/AccountStripeInvoice.vue"
  );

const LogsDashboard = () =>
  import(
    /* webpackChunkName: "group-logs" */ "@/views/ClientLogs/LogsDashboard.vue"
  );
const LogsContactImport = () =>
  import(
    /* webpackChunkName: "group-logs" */ "@/views/ClientLogs/LogsContactImport.vue"
  );
const LogsContact = () =>
  import(
    /* webpackChunkName: "group-logs" */ "@/views/ClientLogs/LogsContact.vue"
  );
const LogsCampaign = () =>
  import(
    /* webpackChunkName: "group-logs" */ "@/views/ClientLogs/LogsCampaign.vue"
  );

const FbChooseType = () =>
  import(
    /* webpackChunkName: "group-formCreate" */ "@/views/builder/form-builder/choose-type.vue"
  );
const FbTemplates = () =>
  import(
    /* webpackChunkName: "group-formCreate" */ "@/views/builder/form-builder/templates.vue"
  );
const FbEditor = () =>
  import(
    /* webpackChunkName: "group-formCreate" */ "@/views/builder/form-builder/editor.vue"
  );
const FbPublish = () =>
  import(
    /* webpackChunkName: "group-formCreate" */ "@/views/builder/form-builder/publish.vue"
  );
const FbList = () =>
  import(
    /* webpackChunkName: "group-list" */ "@/views/builder/form-builder/list.vue"
  );
const FbReport = () =>
  import(
    /* webpackChunkName: "group-list" */ "@/views/builder/form-builder/report.vue"
  );

const ChangePlan = () =>
  import(
    /* webpackChunkName: "group-formCreate" */ "@/views/AccountSettings/ChangePlan.vue"
  );
const PaymentMethod = () =>
  import(
    /* webpackChunkName: "group-formCreate" */ "@/views/AccountSettings/PaymentMethod.vue"
  );

Vue.use(Router);

const recipientActivity = {
  path: "/recipients/activity/:id",
  name: "RecipientActivity",
  component: RecipientActivity,
  meta: {
    requiresAuth: true,
    permissions: [0, 1, 2, 3],
    title: "Recipients Activity - Mailercloud",
  },
};
const campaignPreview = {
  path: "/campaign-preview/:id",
  name: "CampaignPreview",
  component: CampaignPreview,
  meta: {
    requiresAuth: true,
    permissions: [0, 1, 2, 3, 4],
    title: "Preview Campaign - Mailercloud",
  },
};

const router = new Router({
  mode: "history",
  linkExactActiveClass: "active",
  routes: [
    {
      path: "/route-map",
      name: "HelloWorld",
      component: HelloWorld,
    },
    {
      path: "/",
      redirect: "login",
      component: AuthLayout,
      children: [
        {
          path: "/login/reset",
          name: "LoginReset",
          component: LoginReset,
          meta: { title: "Password Reset - Mailercloud" },
        },
        {
          path: "/login/:token?",
          name: "Login",
          component: Login,
          meta: { title: "Login - Mailercloud" },
        },
        {
          path: "/autoLogin/:token?",
          name: "autoLogin",
          component: Login,
          meta: { isAutomation: true, title: "Login - Mailercloud" },
        },
        {
          path: "/autoLogin/reset",
          name: "autoLoginReset",
          component: LoginReset,
          meta: { isAutomation: true, title: "Password Reset - Mailercloud" },
        },
        {
          path: "/reset/:token",
          name: "ResetPassword",
          component: ResetPassword,
          meta: { title: "Password Reset - Mailercloud" },
        },
        {
          path: "/account/user/verify/:token",
          name: "accountVerify",
          component: ResetPassword,
          meta: { title: "Verify Account - Mailercloud" },
        },
        {
          path: "/register",
          name: "Register",
          component: Register,
        },
        {
          path: "/covid/account-activation-request-success",
          name: "CovidRequestSuccess",
          component: RegisterSuccess,
        },
        {
          path: "/account-activation-request-success",
          name: "AccountRequestSuccess",
          component: RegisterSuccess,
        },
        {
          path: "/autoRegister",
          name: "autoRegister",
          component: Register,
          meta: { isAutomation: true },
        },
        {
          path: "/register/address",
          name: "RegisterAddress",
          component: RegisterAddress,
          meta: { requiresAuth: true, title: "Register Address - Mailercloud" },
        },
        {
          path: "/covidcare-initiative/registration-success",
          name: "CovidRegisterSuccess",
          component: RegisterAddress,
          meta: {
            requiresAuth: true,
            title: "Registration Success - Mailercloud",
          },
        },
        {
          path: "/registration-success",
          name: "NormalRegisterSuccess",
          component: RegisterAddress,
          meta: {
            requiresAuth: true,
            title: "Registration Success - Mailercloud",
          },
        },
      ],
    },
    {
      path: "/",
      redirect: "dashboard",
      component: BuilderLayout,
      children: [
        {
          path: "/webform/create",
          name: "CreateWebform",
          component: FbChooseType,
          meta: {
            requiresAuth: true,
            permissions: [0, 1, 2, 3],
            title: "Create Webform - Mailercloud",
          },
        },
        {
          path: "/webform/choose-templates/:id",
          name: "WebformChooseTemplates",
          component: FbTemplates,
          meta: {
            requiresAuth: true,
            permissions: [0, 1, 2, 3],
            title: "Choose Webform Template - Mailercloud",
          },
        },
        {
          path: "/webform/edit/:id",
          name: "WebformEdit",
          component: FbEditor,
          meta: {
            requiresAuth: true,
            permissions: [0, 1, 2, 3],
            title: "Edit Webform - Mailercloud",
          },
        },
        {
          path: "/webform/publish/:id",
          name: "WebformPublish",
          component: FbPublish,
          meta: {
            requiresAuth: true,
            permissions: [0, 1, 2, 3],
            title: "Publish Webform - Mailercloud",
          },
        },
      ],
    },
    {
      path: "/",
      redirect: "dashboard",
      component: ContentLayout,
      children: [
        {
          path: "/change-plan",
          name: "ChangePlan",
          component: ChangePlan,
          meta: { requiresAuth: true, title: "Change plan - Mailercloud" },
        },
        {
          path: "/payment-method",
          name: "PaymentMethod",
          component: PaymentMethod,
          meta: { requiresAuth: true, title: "Payment method - Mailercloud" },
        },
      ],
    },
    {
      path: "/",
      redirect: "dashboard",
      component: DashboardLayout,
      children: [
        {
          path: "/dashboard",
          name: "Dashboard",
          component: Dashboard,
          meta: { requiresAuth: true, title: "Dashboard - Mailercloud" },
        },
        {
          path: "/campaigns",
          name: "Campaign",
          component: Campaign,
          meta: {
            requiresAuth: true,
            permissions: [0, 1, 2, 3, 4],
            title: "Regular Campaigns - Mailercloud",
          },
        },
        {
          path: "/automation",
          name: "Automation",
          component: Automation,
          meta: {
            requiresAuth: true,
            permissions: [0, 1, 2, 3, 4],
            title: "Email Automations - Mailercloud",
          },
        },
        {
          path: "/advanced-automation",
          name: "AdvancedAutomation",
          component: Automation,
          meta: {
            requiresAuth: true,
            permissions: [0, 1, 2, 3, 4],
            title: "Email Automations - Mailercloud",
          },
        },
        {
          path: "/automation-report",
          name: "AutomationReport",
          component: AutomationReport,
          meta: {
            requiresAuth: true,
            title: "Automation Report - Mailercloud",
          },
        },
        {
          path: "/advanced-automation-report",
          name: "AdvancedAutomationReport",
          component: AutomationReport,
          meta: {
            requiresAuth: true,
            title: "Advanced Automation Report - Mailercloud",
          },
        },
        {
          path: "/autoresponder",
          name: "Autoresponder",
          component: Autoresponder,
          meta: {
            requiresAuth: true,
            permissions: [0, 1, 2, 3, 4],
            title: "Autoresponder - Mailercloud",
          },
        },
        {
          path: "/recipients",
          name: "Recipients",
          component: Recipients,
          meta: {
            requiresAuth: true,
            permissions: [0, 1, 2, 3],
            title: "Contact List- Mailercloud",
          },
        },
        {
          path: "/contact-tag",
          name: "ContactTag",
          component: ContactTag,
          meta: {
            requiresAuth: true,
            permissions: [0, 1, 2, 3],
            title: "Contact Tag- Mailercloud",
          },
        },
        {
          path: "/contact-summary/",
          name: "ContactSummary",
          component: ContactSummary,
          meta: { requiresAuth: true, title: "Contact Summary - Mailercloud" },
        },
        {
          path: "/segment",
          name: "Segment",
          component: Segment,
          meta: {
            requiresAuth: true,
            permissions: [0, 1, 2, 3],
            title: "Segment - Mailercloud",
          },
        },
        {
          path: "/gallery",
          name: "Gallery",
          component: Gallery,
          meta: {
            requiresAuth: true,
            permissions: [0, 1, 2, 3, 4],
            title: "Template Gallery - Mailercloud",
          },
        },
        {
          path: "/mailercloud-templates",
          name: "McTemplatesList",
          component: TemplatesList,
          meta: {
            requiresAuth: true,
            requiresTempAccess: true,
            permissions: [0, 1, 2, 3, 4],
            title: "MC Templates - Mailercloud",
          },
        },
        {
          path: "/mailercloud-templates/edit/:id",
          name: "EditMcTemplate",
          component: TemplatesList,
          meta: {
            requiresAuth: true,
            requiresTempAccess: true,
            permissions: [0, 1, 2, 3, 4],
            title: "MC Templates - Mailercloud",
          },
        },
        {
          path: "/campaign-report",
          name: "CampaignReport",
          component: CampaignReport,
          meta: {
            requiresAuth: true,
            title: "Regular Campaign Report - Mailercloud",
          },
        },
        {
          path: "/autoresponder-report",
          name: "AutoresponderReport",
          component: AutoresponderReport,
          meta: {
            requiresAuth: true,
            title: "Autoresponder Report - Mailercloud",
          },
        },
        {
          path: "/activate/:token",
          name: "Activate",
          component: Activate,
          meta: { requiresAuth: true },
        },
        {
          path: "/list-analytics",
          name: "ListAnalytics",
          component: ListAnalytics,
          meta: { requiresAuth: true, title: "List Analytics - Mailercloud" },
        },
        {
          path: "/list-logs",
          name: "Listlogs",
          component: Listlogs,
          meta: { requiresAuth: true, title: "List Logs - Mailercloud" },
        },
        {
          path: "/webform",
          name: "Webform",
          component: FbList,
          meta: {
            requiresAuth: true,
            permissions: [0, 1, 2, 3],
            title: "Webforms - Mailercloud",
          },
        },
        {
          path: "/webform-report",
          name: "WebformReport",
          component: FbReport,
          meta: {
            requiresAuth: true,
            permissions: [0, 1, 2, 3, 4, 5],
            title: "Webform Report - Mailercloud",
          },
        },
        {
          path: "/account",
          component: AccoutDashboard,
          children: [
            {
              path: "",
              name: "AccountOverview",
              component: AccountOverview,
              meta: {
                requiresAuth: true,
                permissions: [0, 1, 2],
                title: "Account Overview - Mailercloud",
              },
            },
            {
              path: "users",
              name: "AccountUserManagement",
              component: AccountUserManagement,
              meta: {
                requiresAuth: true,
                permissions: [0, 1, 2],
                title: "Manage Users - Mailercloud",
              },
            },
            {
              path: "delete",
              name: "AccountDelete",
              component: AccountDelete,
              meta: {
                requiresAuth: true,
                permissions: [0, 1],
                title: "Delete Account - Mailercloud",
              },
            },
            {
              path: "domains",
              name: "AccountDomain",
              component: AccountDomain,
              meta: {
                requiresAuth: true,
                permissions: [0, 1, 2, 3],
                title: "Domains - Mailercloud",
              },
            },
            {
              path: "api-integrations",
              name: "AccountApiIntegrations",
              component: AccountApiIntegrations,
              meta: { requiresAuth: true, permissions: [0, 1, 2, 3] },
            },
            {
              path: "invoices",
              name: "StripeInvoices",
              component: AccountStripeInvoice,
              meta: {
                requiresAuth: true,
                permissions: [0, 1, 2],
                title: "Invoices - Mailercloud",
              },
            },
            {
              path: "payment-methods",
              name: "StripePaymentMethod",
              component: StripePaymentMethod,
              meta: {
                requiresAuth: true,
                permissions: [0, 1, 2],
                title: "Payment Methods - Mailercloud",
              },
            },
            {
              path: "plan",
              name: "AccountPlan",
              component: AccountPlan,
              meta: {
                requiresAuth: true,
                permissions: [0, 1, 2],
                title: "Plan and Pricing - Mailercloud",
              },
            },
            {
              path: "conversion-pixel",
              name: "AccountConversionPixel",
              component: AccountConversionPixel,
              meta: {
                requiresAuth: true,
                permissions: [0, 1, 2, 3],
                title: "Conversion Pixel - Mailercloud",
              },
            },
            {
              path: "sender-management",
              name: "AccountSenderManagement",
              component: AccountSenderManagement,
              meta: {
                requiresAuth: true,
                permissions: [0, 1, 2, 3],
                title: "Sender Management - Mailercloud",
              },
            },
            {
              path: "reply-ids",
              name: "AccountReplyId",
              component: AccountReplyId,
              meta: {
                requiresAuth: true,
                permissions: [0, 1, 2, 3],
                title: "Reply Ids - Mailercloud",
              },
            },
            {
              path: "campaign-tag",
              name: "CampaignTag",
              component: CampaignTag,
              meta: {
                requiresAuth: true,
                permissions: [0, 1, 2, 3],
                title: "Campaign Tags - Mailercloud ",
              },
            },
            {
              path: "contact-properties",
              name: "ContactProperties",
              component: ContactProperties,
              meta: {
                requiresAuth: true,
                permissions: [0, 1, 2, 3],
                title: "Contact Properties - Mailercloud",
              },
            },
            {
              path: "plugins",
              name: "AccountPlugins",
              component: AccountPlugins,
              meta: {
                requiresAuth: true,
                permissions: [0, 1, 2, 3],
                title: "Plugins - Mailercloud",
              },
            },
            {
              path: "rewards",
              name: "AccountRewards",
              component: AccountRewards,
              meta: { requiresAuth: true, title: "Rewards - Mailercloud" },
            },
          ],
        },
        {
          path: "/logs",
          component: LogsDashboard,
          children: [
            {
              path: "contact/import",
              name: "LogsContactImport",
              component: LogsContactImport,
              meta: {
                requiresAuth: true,
                permissions: [0, 1],
                title: "Contact Import Logs - Mailercloud",
              },
            },
            {
              path: "contact",
              name: "LogsContact",
              component: LogsContact,
              meta: {
                requiresAuth: true,
                permissions: [0, 1],
                title: "Contact Activity Logs - Mailercloud",
              },
            },
            {
              path: "campaign",
              name: "LogsCampaign",
              component: LogsCampaign,
              meta: {
                requiresAuth: true,
                permissions: [0, 1],
                title: "Campaign Logs - Mailercloud",
              },
            },
          ],
        },
      ],
    },
    {
      path: "/subscription-preference",
      name: "SubscriptionPreference",
      component: SubscriptionPreference,
    },
    {
      path: "/create-campaign",
      name: "CreateCampaign",
      component: CreateCampaign,
      meta: {
        requiresAuth: true,
        permissions: [0, 1, 2, 3, 4],
        title: "Create Campaign - Mailercloud",
      },
    },
    {
      path: "/automation-campaign/:id?",
      name: "CreateAutomationCampaign",
      component: CreateCampaign,
      meta: { requiresAuth: true, permissions: [0, 1, 2, 3, 4] },
    },
    {
      path: "/edit-campaign/:id",
      name: "EditCampaign",
      component: CreateCampaign,
      meta: {
        requiresAuth: true,
        permissions: [0, 1, 2, 3, 4],
        title: "Edit Campaign - Mailercloud",
      },
    },
    {
      path: "/choose-recipients/:id",
      name: "ChooseRecipients",
      component: ChooseRecipients,
      meta: {
        requiresAuth: true,
        permissions: [0, 1, 2, 3, 4],
        title: "Choose Contacts - Mailercloud",
      },
    },
    campaignPreview,
    {
      ...campaignPreview,
      path: "/automation/:automationId/campaign-preview/:id",
      name: "AutoCampaignPreview",
    },
    {
      path: "/campaign-summary/:id",
      name: "CampaignSummary",
      component: CampaignPreview,
      meta: {
        requiresAuth: true,
        permissions: [0, 1, 2, 3, 4],
        title: "Campaign Preview - Mailercloud",
      },
    },
    {
      path: "/campaign-report-preview/:id",
      name: "CampaignReportPreview",
      component: CampaignPreview,
      meta: {
        requiresAuth: true,
        permissions: [0, 1, 2, 3, 4, 5],
        title: "Campaign Report Preview - Mailercloud",
      },
    },
    {
      path: "/campaign-schedule/success",
      name: "ScheduleSuccess",
      component: ScheduleSuccess,
      meta: {
        requiresAuth: true,
        permissions: [0, 1, 2, 3, 4],
        title: "Publish Campaign - Mailercloud",
      },
    },
    {
      path: "/autoresponder-preview/:id",
      name: "AutoresponderPreview",
      component: CampaignPreview,
      meta: {
        requiresAuth: true,
        permissions: [0, 1, 2, 3, 4],
        title: "Preview Autoresponder - Mailercloud",
      },
    },
    {
      path: "/autoresponder-report-preview/:id",
      name: "AutoresponderReportPreview",
      component: CampaignPreview,
      meta: {
        requiresAuth: true,
        permissions: [0, 1, 2, 3, 4, 5],
        title: "Autoresponder Report Preview - Mailercloud",
      },
    },
    {
      path: "/autoresponder/create",
      name: "CreateAutoresponder",
      component: CreateCampaign,
      meta: {
        requiresAuth: true,
        permissions: [0, 1, 2, 3, 4],
        title: "Create Autoresponder - Mailercloud",
      },
    },
    {
      path: "/autoresponder/edit/:id",
      name: "EditAutoresponder",
      component: CreateCampaign,
      meta: {
        requiresAuth: true,
        permissions: [0, 1, 2, 3, 4],
        title: "Edit Autoresponder - Mailercloud",
      },
    },
    {
      path: "/autoresponder/choose-campaigns/:id",
      name: "ChooseCampaigns",
      component: CreateAutoresponder,
      meta: {
        requiresAuth: true,
        permissions: [0, 1, 2, 3, 4],
        title: "Choose Campaigns - Mailercloud",
      },
    },
    {
      path: "/create-campaign/advanced/:encString",
      name: "CreateAdvAutoCampaign",
      component: CreateCampaign,
      meta: {
        requiresAuth: true,
        permissions: [0, 1, 2, 3, 4],
        title: "Create Campaign - Mailercloud",
      },
    },
    {
      path: "/edit-campaign/advanced/edit/:encString/:id",
      name: "EditAdvAutoCampaign",
      component: CreateCampaign,
      meta: {
        requiresAuth: true,
        permissions: [0, 1, 2, 3, 4],
        title: "Edit Campaign - Mailercloud",
      },
    },
    {
      path: "/create-template/template-themes",
      name: "TemplateThemes",
      component: TemplateThemes,
      meta: {
        requiresAuth: true,
        permissions: [0, 1, 2, 3, 4],
        title: "Template Themes - Mailercloud",
      },
    },
    {
      path: "/create-template/template-layout",
      name: "TemplateLayout",
      component: TemplateLayout,
      meta: {
        requiresAuth: true,
        permissions: [0, 1, 2, 3, 4],
        title: "Template Layouts - Mailercloud",
      },
    },
    {
      path: "/create-template/template-code",
      name: "TemplateCode",
      component: TemplateCodeYourOwn,
      meta: {
        requiresAuth: true,
        permissions: [0, 1, 2, 3, 4],
        title: "Code Your Own Template - Mailercloud",
      },
    },
    {
      path: "/template/import-html",
      name: "ImportHtml",
      component: ImportHtml,
      meta: {
        requiresAuth: true,
        permissions: [0, 1, 2, 3, 4],
        title: "Import HTML - Mailercloud",
      },
    },
    {
      path: "/template/paste-code/:id?",
      name: "PasteCode",
      component: PasteCode,
      meta: {
        requiresAuth: true,
        permissions: [0, 1, 2, 3, 4],
        title: "Paste Code - Mailercloud",
      },
    },
    {
      path: "/template/builder/:id",
      name: "TemplateBuilder",
      component: TemplateBuilder,
      meta: {
        requiresAuth: true,
        permissions: [0, 1, 2, 3, 4],
        title: "Template Builder - Mailercloud",
      },
    },
    {
      path: "/template/import-zip",
      name: "ImportZip",
      component: ImportZip,
      meta: {
        requiresAuth: true,
        permissions: [0, 1, 2, 3, 4],
        title: "Import Zip - Mailercloud",
      },
    },

    {
      path: "/recipients/add/:id?",
      name: "CreateListType",
      component: CreateListType,
      meta: {
        requiresAuth: true,
        permissions: [0, 1, 2, 3],
        title: "Create Contact List - Mailercloud",
      },
    },

    {
      path: "/recipients/import/:id",
      name: "CreateListImport",
      component: CreateListImport,
      meta: {
        requiresAuth: true,
        permissions: [0, 1, 2, 3],
        title: "Import Contacts - Mailercloud",
      },
    },
    {
      path: "/add-contacts/import/:id",
      name: "AudienceListImport",
      component: CreateListImport,
      meta: {
        requiresAuth: true,
        permissions: [0, 1, 2, 3],
        title: "Import Contacts - Mailercloud",
      },
    },
    {
      path: "/recipients/upload/:id",
      name: "CreateListUpload",
      component: CreateListUpload,
      meta: {
        requiresAuth: true,
        permissions: [0, 1, 2, 3],
        title: "Upload Contact File - Mailercloud",
      },
    },
    {
      path: "/import-contacts/upload/:id",
      name: "AudienceListUpload",
      component: CreateListUpload,
      meta: {
        requiresAuth: true,
        permissions: [0, 1, 2, 3],
        title: "Upload Contact File - Mailercloud",
      },
    },
    {
      path: "/recipients/import/map/:id",
      name: "CreateListUploadMap",
      component: CreateListUploadMap,
      meta: {
        requiresAuth: true,
        permissions: [0, 1, 2, 3],
        title: "Map Columns - Mailercloud",
      },
    },
    {
      path: "/recipients/copy/map/:id",
      name: "CopyPaistemap",
      component: CreateListUploadMap,
      meta: {
        requiresAuth: true,
        permissions: [0, 1, 2, 3],
        title: "Map Columns - Mailercloud",
      },
    },
    {
      path: "/import-contacts/import/map/:id",
      name: "AudienceListUploadMap",
      component: CreateListUploadMap,
      meta: {
        requiresAuth: true,
        permissions: [0, 1, 2, 3],
        title: "Map Columns - Mailercloud",
      },
    },
    {
      path: "/import-contacts/copy/map/:id",
      name: "AudienceCopyPaistemap",
      component: CreateListUploadMap,
      meta: {
        requiresAuth: true,
        permissions: [0, 1, 2, 3],
        title: "Map Columns - Mailercloud",
      },
    },
    {
      path: "/recipients/copy-paste/:id",
      name: "CreateListCopyPaste",
      component: CreateListCopyPaste,
      meta: {
        requiresAuth: true,
        permissions: [0, 1, 2, 3],
        title: "Copy and Paste Contacts - Mailercloud",
      },
    },
    {
      path: "/import-contacts/copy-paste/:id",
      name: "AudienceListCopyPaste",
      component: CreateListCopyPaste,
      meta: {
        requiresAuth: true,
        permissions: [0, 1, 2, 3],
        title: "Copy and Paste Contacts - Mailercloud",
      },
    },
    {
      path: "/recipients/individual/:id",
      name: "CreateListIndividual",
      component: CreateListIndividual,
      meta: {
        requiresAuth: true,
        permissions: [0, 1, 2, 3],
        title: "Add Individual Contacts - Mailercloud",
      },
    },
    {
      path: "/add-contacts/individual/:id",
      name: "AudienceListIndividual",
      component: CreateListIndividual,
      meta: {
        requiresAuth: true,
        permissions: [0, 1, 2, 3],
        title: "Add Individual Contacts - Mailercloud",
      },
    },
    {
      path: "/recipients/subscribers/:id",
      name: "RecipientsAnalytics",
      component: RecipientsAnalytics,
      meta: {
        requiresAuth: true,
        permissions: [0, 1, 2, 3],
        title: "Recipients Analytics - Mailercloud",
      },
    },
    recipientActivity,
    {
      ...recipientActivity,
      path: "/automation/:automationId/activity/:id",
      name: "RecipientActivityAuto",
    },
    {
      path: "/segment/activity/:id",
      name: "SegmentActivity",
      component: RecipientActivity,
      meta: {
        requiresAuth: true,
        permissions: [0, 1, 2, 3],
        title: "Segment Activity - Mailercloud",
      },
    },
    {
      path: "/webform/activity/:id",
      name: "webformActivity",
      component: RecipientActivity,
      meta: {
        requiresAuth: true,
        permissions: [0, 1, 2, 3, 4, 5],
        title: "Webform Recipients Activity - Mailercloud",
      },
    },
    {
      path: "/campaign-analytics/:id",
      name: "CampaignAnalytics",
      component: CampaignAnalytics,
      meta: {
        requiresAuth: true,
        permissions: [0, 1, 2, 3, 4, 5],
        title: "Campaign Analytics - Mailercloud",
      },
    },
    {
      path: "/autoresponder-analytics/:id",
      name: "AutoresponderAnalytics",
      component: CampaignAnalytics,
      meta: {
        requiresAuth: true,
        permissions: [0, 1, 2, 3, 4, 5],
        title: "Autoresponder Analytics - Mailercloud",
      },
    },
    {
      path: "/automation-detail-report/:id",
      name: "AutomationReportDetail",
      component: AutomationReportDetail,
      meta: {
        requiresAuth: true,
        title: "Automation Detail Report - Mailercloud",
      },
    },
    {
      path: "/automation-campaign-analytics/:id",
      name: "AutomationCampAnalytics",
      component: CampaignAnalytics,
      meta: { requiresAuth: true, permissions: [0, 1, 2, 3, 4, 5] },
    },
    {
      path: "/advanced-automation-campaign-analytics/:id",
      name: "AdvancedAutomationCampAnalytics",
      component: CampaignAnalytics,
      meta: { requiresAuth: true, permissions: [0, 1, 2, 3, 4, 5] },
    },
    {
      path: "/segment/analytics/:id",
      name: "SegmentsAnalytics",
      component: SegmentsAnalytics,
      meta: {
        requiresAuth: true,
        permissions: [0, 1, 2, 3],
        title: "Segment Analytics - Mailercloud",
      },
    },
    {
      path: "/segment/create/:id?",
      name: "CreateSegment",
      component: CreateSegment,
      meta: {
        requiresAuth: true,
        permissions: [0, 1, 2, 3],
        title: "Create Segment - Mailercloud",
      },
    },
    {
      path: "/create-ab-split",
      name: "CreateAbSplit",
      component: CreateAbSplit,
      meta: {
        requiresAuth: true,
        permissions: [0, 1, 2, 3, 4],
        title: "A/B Split Campaign - Mailercloud",
      },
    },
    {
      path: "/edit-ab-split/:id",
      name: "EditABCampaign",
      component: CreateAbSplit,
      meta: {
        requiresAuth: true,
        permissions: [0, 1, 2, 3, 4],
        title: "Edit A/B Split Camapign - Mailercloud",
      },
    },
    {
      path: "/email-automation",
      name: "CreateAutomation",
      component: CreateAutomation,
      meta: { requiresAuth: true, permissions: [0, 1, 2, 3, 4] },
    },
    {
      path: "/automation-create",
      name: "AutomationStep1",
      component: AutomationStep1,
      meta: {
        requiresAuth: true,
        permissions: [0, 1, 2, 3, 4],
        title: "Create Email Automation  - Mailercloud",
      },
    },
    {
      path: "/create-automation-flow/:id",
      name: "AutomationStep2",
      component: AutomationStep2,
      meta: {
        requiresAuth: true,
        permissions: [0, 1, 2, 3, 4],
        title: "Choose Automation Camapigns - Mailercloud",
      },
    },
    {
      path: "/automation-edit/:id",
      name: "AutomationEditStep1",
      component: AutomationStep1,
      meta: {
        requiresAuth: true,
        permissions: [0, 1, 2, 3, 4],
        title: "Edit Email Automation - Mailercloud",
      },
    },
    {
      path: "/edit-automation-flow/:id",
      name: "AutomationEditStep2",
      component: AutomationStep2,
      meta: {
        requiresAuth: true,
        permissions: [0, 1, 2, 3, 4],
        title: "Update Automation Camapigns - Mailercloud",
      },
    },
    {
      path: "/automation-view/:id",
      name: "AutomationStep3",
      component: AutomationStep3,
      meta: {
        requiresAuth: true,
        permissions: [0, 1, 2, 3, 4],
        title: "Email Automation Preview - Mailercloud",
      },
    },
    {
      path: "/automation-edit-view/:id",
      name: "AutomationEditStep3",
      component: AutomationStep3,
      meta: {
        requiresAuth: true,
        permissions: [0, 1, 2, 3, 4],
        title: "Email Automation Preview - Mailercloud",
      },
    },
    {
      path: "/automation-preview/:id",
      name: "AutomationPreview",
      component: AutomationStep3,
      meta: {
        requiresAuth: true,
        title: "Email Automation Preview - Mailercloud",
      },
    },
    {
      path: "/create-advance-automation",
      name: "AdvAutomationStep1",
      component: AdvAutomationStep1,
      meta: {
        requiresAuth: true,
        permissions: [0, 1, 2, 3, 4],
        title: "Create Advanced Email Automation  - Mailercloud",
      },
    },
    {
      path: "/admin/:key",
      name: "AdminLogin",
      component: AdminLogin,
    },

    {
      path: "*",
      name: "PageNotFound",
      component: ErrorView,
    },
    {
      path: "/under-maintenance",
      name: "UnderMaintenance",
      component: UnderMaintenance,
    },
  ],
});

router.beforeEach((to, from, next) => {
  if (to.meta.isAutomation && !parseInt(process.env.VUE_APP_AUTOTEST_ENABLED)) {
    showLoader();
    if (to.name === "autoLogin") {
      next({ name: "Login" });
    } else if (to.name === "autoRegister") {
      next({ name: "Register" });
    } else if (to.name === "autoLoginReset") {
      next({ name: "LoginReset" });
    }
    return;
  }

  var isApproved = !(
    Vue.ls.get("is_approve") && parseInt(Vue.ls.get("is_approve")) === 0
  );

  if (
    (to.name === "CreateAutoresponder" || to.name === "CreateAbSplit") &&
    !isApproved
  ) {
    next("/permission-denied");
    return;
  }

  var loginData = JSON.parse(Vue.ls.get("login_data"));
  var permission = Vue.ls.get("permission");
  if (loginData && loginData.token && permission !== null) {
    var addComplete = Vue.ls.get("address_completed");
    if (
      (addComplete === false || addComplete === "false") &&
      to.name !== "RegisterAddress" &&
      to.name !== "AdminLogin"
    ) {
      showLoader();
      next({ name: "RegisterAddress" });
      return;
    }

    if (
      (addComplete === true || addComplete === "true") &&
      to.name === "RegisterAddress"
    ) {
      next({ name: "Dashboard" });
      return;
    }
  }
  if (
    loginData &&
    loginData.isLiftime &&
    ["AccountPlan", "ChangePlan"].includes(to.name)
  ) {
    next({ name: "AccountOverview" });
    return;
  }
  if (to.meta.requiresAuth) {
    if (!loginData || !loginData.token || permission === null) {
      showLoader();
      next({ name: "Login" });
    } else {
      showLoader();
      if (to.meta.requiresTempAccess && loginData && !loginData.mcTemplate) {
        Vue.ls.remove("login_data");
        next({ name: "Login" });
        return;
      }

      if (!Vue.ls.get("is_campaign_add")) {
        Vue.ls.remove("login_data");
        next({ name: "Login" });
        return;
      }

      permission = parseInt(permission);
      if (to.meta.permissions && to.meta.permissions.indexOf(permission) < 0) {
        next("/permission-denied");
        return;
      }
      var expireTime = Vue.ls.get("expired_time");
      if (expireTime) {
        expireTime = expireTime.split("_");
        if (expireTime.length > 1) {
          if (
            parseInt(expireTime[0] * 1000) + parseInt(expireTime[1]) <
            new Date().getTime()
          ) {
            Vue.ls.remove("login_data");
            next({ name: "Login" });
          } else {
            next();
          }
        } else {
          Vue.ls.remove("login_data");
          next({ name: "Login" });
        }
      } else {
        Vue.ls.remove("login_data");
        next({ name: "Login" });
      }
    }
  } else if (
    loginData &&
    loginData.token &&
    to.name === "Login" &&
    permission !== null &&
    !to.params.token
  ) {
    showLoader();
    next({ name: "Dashboard" });
  } else {
    showLoader();
    next();
  }
});

function showLoader() {
  NProgress.configure({ showSpinner: false });
  NProgress.start();
  NProgress.inc();
}

router.afterEach(() => {
  setTimeout(() => {
    NProgress.done();
  }, 500);
});

router.onError((error) => {
  if (/Loading chunk [\d\w]* failed./i.test(error.message)) {
    window.location.reload();
  }
});

export default router;
